import { Component, OnInit, input } from '@angular/core';
import { DynamicComponent } from '../dynamic';

@Component({
    selector: 'mutara-organization-tree',
    templateUrl: './organization-tree.component.html',
    styleUrls: ['./organization-tree.component.scss'],
    standalone: false
})
export class OrganizationTreeComponent implements OnInit, DynamicComponent {
  readonly objectData = input<any>(undefined);

  constructor() { }

  catchChip(event: import("@angular/cdk/drag-drop").CdkDragDrop<string[], string[]>) {
    throw new Error("Method not implemented.");
  }

  ngOnInit(): void {
  }

}
